/*
  Files rules:
  - max size 4MB
  - allowed mimetypes and formats:
    - image:
      - APNG (MIME type image/apng, extension(s) .apng)
      - GIF (MIME type image/gif, extension(s) .gif)
      - JPEG (MIME type image/jpeg, extension(s) .jpg, .jpeg, .jpe, .jif, .jfif)
      - PNG (MIME type image/png, extension(s) .png)
    - pdf:
      - PDF (MIME type application/pdf, extension(s) .pdf)
*/

import { t } from "../../../hooks/useAppTranslation";
import {useRef, useState} from 'react';

import PopUp from '../../PopUp/PopUp';
import {downloadFile} from '../helpers';
import {File} from './File';
import {PreviewUnavailable} from './PreviewUnavailable';


const MAX_SIZE = 4 * 1024 * 1024;
const EXTENSIONS_DICT = {
  'apng': {mimeType: 'image/apng', previewType: 'image'},
  'gif': {mimeType: 'image/gif', previewType: 'image'},
  'jpg': {mimeType: 'image/jpeg', previewType: 'image'},
  'jpeg': {mimeType: 'image/jpeg', previewType: 'image'},
  'jpe': {mimeType: 'image/jpeg', previewType: 'image'},
  'jif': {mimeType: 'image/jpeg', previewType: 'image'},
  'jfif': {mimeType: 'image/jpeg', previewType: 'image'},
  'png': {mimeType: 'image/png', previewType: 'image'},
  'pdf': {mimeType: 'application/pdf', previewType: 'pdf'},
};


export const FilePreview = ({ buttonClassName, buttonDisabled, fileData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const fileContainerRef = useRef();

  function handleClose() { setIsOpen(false); }

  const {
    extension = undefined,
    fileName,
    id: fileId,
    mimeType = 'undefined',
    size = 2 * MAX_SIZE,
  } = fileData;
  const extensionData = EXTENSIONS_DICT[extension.toLowerCase()];

  let previewAvailable = true;
  if (!size || size > MAX_SIZE) {
    previewAvailable = false;
  } else {
    if (!extensionData || extensionData.mimeType !== mimeType) {
      previewAvailable = false;
    }
  }

  return (
    <>
      <button
        className={`btn save-btn${buttonClassName ? ` ${buttonClassName}` : ''}`}
        disabled={buttonDisabled}
        type="button"
        onClick={() => setIsOpen(true)}
      >
        { t('g-preview') }<span className="sr-only"> {fileName}</span>
      </button>
      {isOpen &&
        <PopUp
          className="documents"
          customContent
          notification=""
          title={t('g-attachment-preview')}
          handleClosePopup={handleClose}
        >
          <div className="popUp__content-scrolled image-preview__content">
            {previewAvailable
              ? <File fileId={fileId} fileType={extensionData.previewType} />
              : <PreviewUnavailable />
            }
          </div>
			<div className="col-12 documents__btn-flex" ref={fileContainerRef}>
				<button className="btn delete-btn" type="button" onClick={handleClose}>
					{ t('g-close') }
				</button>
				<button
					className="btn save-btn"
					type="button"
					onClick={() => downloadFile(fileContainerRef.current, fileId, fileName)}
				>
					{ t('g-attachment-download') }
				</button>
			</div>
        </PopUp>
      }
    </>
  )
};
